import { LightningBoltIcon } from './LightningBoltIcon';

/**
 * author: Brooke Clifton
 * id A4A9C031-02B0-45C7-B9C8-EA1541DB9A38
 * name lightning-bolt
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightning-bolt.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const StormIcon = LightningBoltIcon;
export default StormIcon